module.exports = __webpack_public_path__ + "ch.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ch.svg
// module id = 743
// module chunks = 0